var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import * as constants from '@adc/constants';
import configment from '@adc/configment';
import responseParsers, { RetryError } from './responseParsers';
import timeout from './timeout';
import * as common from './common';
import * as types from './types';
import graphFactory from './graph';
import withProgress from './withProgress';
import { usesProxy, generateProxyRoute } from './proxyRoutes';
import wellKnownSymbols from './wellKnownSymbols';
const defaultBrowserOpts = Object.freeze(Object.assign(Object.assign({}, types.defaultFetchOptions), { credentials: 'same-origin', useProxy: true }));
const DEFAULT_FETCH_TIMEOUT = 8000;
const staticFetchOptions = common.defaultStaticFetchOptions;
const patchedFetch = function (url, passedOptions = {}) {
    const requestController = passedOptions.controller || new AbortController();
    passedOptions.requestTimeout = Number(passedOptions.requestTimeout ||
        configment.get('REQUEST_TIMEOUT', DEFAULT_FETCH_TIMEOUT));
    let options = _.merge(_.cloneDeep(defaultBrowserOpts), staticFetchOptions, passedOptions);
    if (_.get(this, '__internal.host')) {
        url = this.__internal.host + url;
    }
    if (options.useProxy && usesProxy(url)) {
        url = generateProxyRoute(url).route;
    }
    url = common.constructUrl(url, options.queryParams);
    common.stripNonStandardFetchOptions(options);
    common.attemptAutomaticBodySerialization(options);
    options.headers['user-agent'] =
        options.headers['user-agent'] || common.userAgent();
    let { tries, retryTimeout, requestTimeout, eventCapture, parseResponse, queryParams, fetchOptionsCheck } = options, fetchOptions = __rest(options, ["tries", "retryTimeout", "requestTimeout", "eventCapture", "parseResponse", "queryParams", "fetchOptionsCheck"]);
    fetchOptions.signal = requestController.signal;
    const execute = () => {
        ;
        fetchOptions.headers[constants.headers.CORRELATION_HEADER] = uuidv4();
        const xsrfValue = Cookies.get(constants.cookies.XSRF_COOKIE);
        if (xsrfValue) {
            ;
            fetchOptions.headers[constants.headers.XSRF_HEADER] = xsrfValue;
        }
        return timeout(timeoutID => common.executeRequest(url, fetchOptions, {
            tries,
            retryTimeout,
            eventCapture,
            parseResponse,
            timeoutID,
            fetchOptionsCheck,
        }), requestTimeout || DEFAULT_FETCH_TIMEOUT, requestController);
    };
    return execute().catch(e => {
        if (e instanceof RetryError) {
            return execute();
        }
        throw e;
    });
};
patchedFetch.get = common.methodFactory(patchedFetch, 'GET');
patchedFetch.post = common.methodFactory(patchedFetch, 'POST');
patchedFetch.put = common.methodFactory(patchedFetch, 'PUT');
patchedFetch.patch = common.methodFactory(patchedFetch, 'PATCH');
patchedFetch.delete = common.methodFactory(patchedFetch, 'DELETE');
patchedFetch.__internal = {};
const forAuctionGraph = graphFactory(patchedFetch);
const fromService = common.boundedFetchFactory(patchedFetch);
const serializeParams = common.serializeParams;
patchedFetch.forAuctionGraph = forAuctionGraph;
patchedFetch.fromService = fromService;
patchedFetch.withProgress = withProgress;
patchedFetch.serializeParams = serializeParams;
patchedFetch.responseParsers = responseParsers;
patchedFetch.staticOptions = staticFetchOptions;
patchedFetch.RetryError = RetryError;
export default patchedFetch;
export { forAuctionGraph, fromService, serializeParams, responseParsers, types, withProgress, wellKnownSymbols, RetryError, };
//# sourceMappingURL=esm.js.map